import InventoryEditExpenses from './InventoryEditExpenses'
export default InventoryEditExpenses
